import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomDivider } from '../../../custom_shared/components';
import WorksheetsPanelHeader from './WorksheetsPanelHeader';
import WorksheetsList from './WorksheetsList';
import './WorksheetsPanel.less';

const WorksheetsPanel: React.FC = () => {
    return (
        <div className="worksheets-panel-container">
            <WorksheetsPanelHeader />
            <CustomDivider type="horizontal" />
            <WorksheetsList />
        </div>
    );
};

export default observer(WorksheetsPanel);
